import type { SegmentMst } from '@libs/domain';

class SingleSegmentMst implements Pick<SegmentMst['schema'], 'key' | 'segmentMstCode'> {
  private constructor(
    readonly key: number,
    readonly segmentMstCode: string,
  ) {}

  static init(key: number) {
    return new SingleSegmentMst(key, '');
  }

  static fromRaw(raw: SingleSegmentMstRaw) {
    return new SingleSegmentMst(raw.key, raw.segmentMstCode);
  }
}

class SingleSegmentMstRaw implements Pick<SegmentMst['record'], 'key' | 'segmentMstCode'> {
  private constructor(
    readonly key: number,
    readonly segmentMstCode: string,
  ) {}

  static fromModel(m: SingleSegmentMst) {
    return new SingleSegmentMstRaw(m.key, m.segmentMstCode);
  }
}

export { SingleSegmentMst, SingleSegmentMstRaw };
